var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Trash_light"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 8",
    d: "M7.9165 12.0833L7.9165 9.58325",
    stroke: "#DA0000",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 9",
    d: "M12.0835 12.0833L12.0835 9.58325",
    stroke: "#DA0000",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 41",
    d: "M2.5 5.41675H17.5V5.41675C16.6463 5.41675 16.2194 5.41675 15.8788 5.54494C15.3398 5.74781 14.9144 6.17322 14.7115 6.71225C14.5833 7.05284 14.5833 7.4797 14.5833 8.33341V12.2501C14.5833 14.1357 14.5833 15.0785 13.9975 15.6643C13.4118 16.2501 12.469 16.2501 10.5833 16.2501H9.41667C7.53105 16.2501 6.58824 16.2501 6.00245 15.6643C5.41667 15.0785 5.41667 14.1357 5.41667 12.2501V8.33341C5.41667 7.47969 5.41667 7.05284 5.28848 6.71225C5.0856 6.17322 4.6602 5.74781 4.12117 5.54494C3.78058 5.41675 3.35372 5.41675 2.5 5.41675V5.41675Z",
    stroke: "#DA0000",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 45",
    d: "M7.91683 2.91679C7.91683 2.91679 8.3335 2.08325 10.0002 2.08325C11.6668 2.08325 12.0835 2.91659 12.0835 2.91659",
    stroke: "#DA0000",
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashLight);
export default __webpack_public_path__ + "static/media/Trash_light.7de3d7fd214b5281a347791154a1bea9.svg";
export { ForwardRef as ReactComponent };